import createModel from 'utils/model'
import {list, create, update, remove, detail, swap} from 'crm/services/extended-data'

export default createModel({
    namespace: 'crm_extendedData',

    state: {
        list: [],
    },

    effects: {
        *list(_, {call, put}) {
            const res = yield call(list)
            yield put({
                type: 'setProperty',
                payload: {
                    list: res?.data || [],
                },
            })
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
        *remove({payload}, {call}) {
            return yield call(remove, payload)
        },
        *detail({payload}, {call}) {
            return yield call(detail, payload)
        },
        *swap({payload}, {call}) {
            return yield call(swap, payload)
        },
    },

    reducers: {},
})
